module.exports = __webpack_public_path__ + "static/highlight-56c2ac562a6f99cfac86a874fb8bb5b8.png";